import {default as _} from 'lodash';
import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { APIURL } from "../Constant/API_Urls";
import { SharedHttpClientService } from "./shared-http-client.service";
import { UrlsService } from "./urls.service";
import { DatePipe } from "@angular/common";
import { StorageKeys } from "../Constant/StorageKeys";
import { ConstantService } from "./constant-service";
import { IdleService } from './idle.service';
import { ServiceList } from "../Model/shared.model";
import { HttpErrorResponse } from "@angular/common/http";
@Injectable(
  {providedIn: 'root'}
)
export class UserService {
  public userName: any;
  public userFirstName: any;
  public caisExceptionType: any;
  public role: any;
  MPIDList: any;
  days: any;
  uid!: any;
  BackUrl: any;
  public activeMPID: any;
  currentuser: any;
  JWTToken: any;
  timeStampErrorField="";
  public CRDID: any;
  public CATFinraRejectsROECount: any = 0;
  public CATPreValidationROECount: any = 0;
  public ReceivedFilesCount: any = 0;
  public CATFinraSubmittedFileCount: any = 0;
  public CATDashboard_LastExecutionDate: any = null;
  public CATLastExecutionDate: any = new Date();
  public CATAnalyticsLastExecutionReportDate: any = new Date();
  public CATLastFinraSubmitDate: any = new Date();
  public FinraCATFirstExceptionReportDate: any = new Date();
  public FinraCATLastExceptionReportDate: any = new Date();
  public LastClientReportDate: any = new Date();
  public FirstClientReportDate: any = new Date();
  public testDatesForClientReportedData: any[] = [new Date(), new Date()];
  public CAT_Field_Dictionary: any = [];
  public CAIS_Field_Dictionary: any = [];
  public Country_Code_List: any = [];
  public Country_Region_Code_List: any = [];
  public handlingInstructionsJSON :any[]= [];
  public handlingInstructions: any = [];
  public catFirstExecutionDate: Date = new Date();
  public equitiSymbolDate: Date = new Date();
  public optionSymbolDate: Date = new Date();
  public MPIDDate: Date = new Date();
  public AuditLastExecutionDate: any = new Date();
  public CAISLastReportDate: any = new Date();
  public CAISFinraLastReportDate: any = new Date();

  public ODR_SystemLogsReportDate: any = null;
  public ODR_ProcessedTransactionReportDate: any = null;

  public SecurityMasterLastExcecutionReportDate: any = null;
  public LogsLastExcecutionReportDate: any = new Date();
  public accountNumbers: Array<any> = [];
  public ltidAccountNumbers: Array<any> = [];
  countryList: any = [];
  countryRegionList: any = [];
  public MPIDServiceList: ServiceList = new ServiceList;
  public CAISFDIDRecordType!: string;
  public showMassCorrection: boolean = false;
  public isEnabledcaisFDIDService: boolean =false;
  public isEnabled606Service: boolean =false;
  futuFirms: any = "FUTC,FUTU,FUTA,FUTM,FUTI,FUTJ,FUTG";
  
  async init() {
    this.days = 30;
    if (this.constantService.getSessionStorage(StorageKeys.User))
      this.currentuser = await JSON.parse(
        this.constantService.getSessionStorage(StorageKeys.User)
      );
    if (this.currentuser) {
      this.userName = this.currentuser.username;
      this.userFirstName = this.currentuser.userFirstName;
      this.role = this.currentuser.mpid[0].role;
    }
    if (this.currentuser != null) {
      this.userName = this.currentuser.username;
      if (this.currentuser.mpid != null) {
        let defaultMPID = JSON.parse(
          this.constantService.getSessionStorage(StorageKeys.MPID)
        );
        this.uid = this.currentuser.mpid[0].uid;
        this.MPIDList = this.currentuser.mpid[0].mpid;
        this.activeMPID = defaultMPID.defaultMPID ? defaultMPID.defaultMPID : this.MPIDList[0].mpid;
        this.urlsService.MPID = this.activeMPID;
        await this.getLastReportedDate();
        await this.getLastReportedClientDate();
        this.getFieldDictionary();
        this.getCAISFieldDictionary();
        this.getAccountNumbers();
        this.getLTIDAccountNumbers();

        this.getMPIDServieList();
        this.getCountryCodeList();

        this.resetODRLastReportDates();
      } else {
        alert("mpid empty");
        if (this.router.url == "/login") {
          this.router.navigate(["/login"]);
        } else {
          this.router.navigate(["/login"]);
        }
      }
    } else {
      this.router.navigate(["/login"]);
    }

     this.idle.setIdle(1);
     this.idle.setTimeout(this.constantService.IDLE_TIMEOUT);
     this.idle.onTimeoutWarning.subscribe((countdown: number) => {
     });
     this.idle.setInterrupts([
       'mousemove', 'keydown', 'mousedown', 'touchstart', 'touchmove', 'scroll', 'wheel', 'click'
     ]);
     this.idle.onTimeout.subscribe(() => {
         // after idle timeout.
         this.router.navigate(['login'])
     });
     this.idle.watch();
  }
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private urlsService: UrlsService,
    private constantService: ConstantService,
    private sharedHttpClientService: SharedHttpClientService,
    private datePipe: DatePipe,
    private urlService: UrlsService,
    private idle: IdleService
  ) {
    
  }

  getFormatedDate(value: any) {
    let tempDate: any = null;
    try{
    if (value) {
      let date: Date = new Date(value);
      tempDate = value !=="" ? new Date( value.split('-')[0],(value.split('-')[1] -1), value.split('-')[2],0,0,1,1): new Date();
      let timedifference = new Date().getTime();
    }
    return tempDate;
  }catch(e){
    return value;
  }
  }
  
  getUTCDate_yyyyMMdd(date: any) {
    let DATE_YYYY_MM_DD:any=null;
    if(date){
      DATE_YYYY_MM_DD= this.getyyyyMMddDateFormate(new Date(this.transformStringtoDate(date)).toLocaleString('en-US', { timeZone: 'UTC' }));
    }
    return DATE_YYYY_MM_DD;
  }

  transformStringtoDate(value: any): any {
    if(value && typeof value !== 'undefined' && value.length==8 && !value.toString().includes("-") ){
    const pattern = /(\d{4})(\d{2})(\d{2})/
    const [year, month, day] = value.toString().match(pattern).slice(1)
    return [year, month, day].join('-')
    }
    return value;
  }

  getyyyyMMddDateFormate(date: any):any {
    try {
      return this.datePipe.transform(this.transformStringtoDate(date), "yyyy-MM-dd");
    }
    catch(e) {
    }
    return null;
  }

  getyyyyMMdd_HH_MM_SSDateFormate(date: any) {
    return this.datePipe.transform(date, "yyyy_MM_dd HH:mm:ss");
  }

  getDateTimeFormate(date: any) {
    return this.datePipe.transform(date, "yyyy/MM/dd HH:mm:ss");
  }

  getFirstDateOfMonth(reportDate:any){
  const firstDateOfMonth = (date = new Date()) =>
  new Date(date.getFullYear(), date.getMonth(), 1);
  return this.getyyyyMMddDateFormate(firstDateOfMonth(reportDate));
  }

  getLastDateOfMonth(reportDate:any){
  const lastDateOfMonth = (date = new Date()) =>
  new Date(date.getFullYear(), date.getMonth() + 1, 0);
  return this.getyyyyMMddDateFormate(lastDateOfMonth(reportDate));
  }

  getDateTimeTFormatePattern(keyName:string){
    if(keyName.toString().includes('Timestamp')){
      return 'yyyyMMddThhmmss.SSSSSS';
    }
    else if(keyName.toString().includes('KeyDate')){
      return 'yyyyMMddT000000';
    }
    return '';
  }

  getDateTimeTFormate(date: any,keyName:any) {
    let formatedDatetime:any =date;
    this.timeStampErrorField='';
    let value = null;
    let milliseconds: string = '000000';
    if (date) {
      milliseconds = date.split('.')[1];
      if (milliseconds) {
        if(milliseconds.length > 6){
          this.timeStampErrorField=keyName;
        }
        milliseconds.replace(/ /g, "").replace(/\s/g, "");
        milliseconds = this.padEnd(milliseconds, 6,'0');
      }else{
        milliseconds = '000000';
      }
      value = this.datePipe.transform(date, "yyyyMMddTHHmmss");
    }

    if (value != null && value != '' && new Date(value)) {
      formatedDatetime = value; 
      if(keyName.toString().includes('Timestamp'))
        formatedDatetime+= '.' + milliseconds;
    } else {
      formatedDatetime = null;
      this.timeStampErrorField=keyName;
    }
    return formatedDatetime;
  }

  padEnd(num:any, size:number,value:any): string {
    let s = num.trim()+"";
    while (s.length < size) s =s+value;
    return s;
}
  getMMMDDFormat(date: any) {
    return this.datePipe.transform(date, "dd-MMM");
  }
  

  getLastReportedClientDate() {
   
    this.get_Last_Reported_ClientDate().subscribe(
      {
        next: (data:any) => {
        let jsondata: any = [];
        jsondata.push(JSON.stringify(data));
        let fromdate: any = jsondata[0].Fromdate != null ? this.getFormatedDate(this.getyyyyMMddDateFormate(jsondata[0].Fromdate)): new Date();
        let todate: any = jsondata[0].Todate != null? this.getFormatedDate(this.getyyyyMMddDateFormate(jsondata[0].Todate)): new Date();
        let Datesdata : Date[] = [];
        Datesdata.push(fromdate);
        Datesdata.push(todate);
        this.SetDatesForClientData(Datesdata);
      },
      error: (err: HttpErrorResponse) => { }
  });
  }

  resetODRLastReportDates() {
    this.ODR_SystemLogsReportDate = null;
    this.ODR_ProcessedTransactionReportDate = null;
  }
  getODRLastReportedDate(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.get_ODR_Last_ReportDate().subscribe({
        next: (res: any) => {
          let jsondata = res;
          if (jsondata) {
            this.ODR_SystemLogsReportDate = jsondata.systemLogLastReportDate !== "" ? this.getFormatedDate(jsondata.systemLogLastReportDate) : new Date();
            this.ODR_ProcessedTransactionReportDate = jsondata.processedTransactionsLastReportDate !== "" ? this.getFormatedDate(jsondata.processedTransactionsLastReportDate) : new Date();
          }
          resolve();
        },
        error: () => resolve()
      });
    });
  }

  getLastReportedDate() {
    this.get_CAT_Last_ReportDate().subscribe((res: any) => {
      let response: any = res;
      let jsondata = response.data[0]
      if(jsondata) {
      this.CATLastExecutionDate = jsondata.CATLastExcecutionReportDate !=="" ? this.getFormatedDate(jsondata.CATLastExcecutionReportDate): new Date();
      this.CATDashboard_LastExecutionDate =  jsondata.CATLastExcecutionReportDate !=="" ? this.getFormatedDate(jsondata.CATLastExcecutionReportDate):null;
      this.catFirstExecutionDate = jsondata.CATFirstExcecutionReportDate !=="" ? this.getFormatedDate(jsondata.CATFirstExcecutionReportDate): new Date();
      this.equitiSymbolDate = jsondata.EquityLastExcecutionReportDate  !=="" ? this.getFormatedDate(jsondata.EquityLastExcecutionReportDate): new Date();
      this.optionSymbolDate = jsondata.OptionLastExcecutionReportDate !=="" ? this.getFormatedDate(jsondata.OptionLastExcecutionReportDate): new Date();
      this.MPIDDate = jsondata.MPIDLastExcecutionReportDate !=="" ? this.getFormatedDate(jsondata.MPIDLastExcecutionReportDate): new Date();
      this.SecurityMasterLastExcecutionReportDate = jsondata.SecurityMasterLastExcecutionReportDate !=="" ? this.getFormatedDate(jsondata.SecurityMasterLastExcecutionReportDate): new Date();
      this.CATLastFinraSubmitDate =  jsondata.FinraSubmitLastExecutionReportDate !=="" ? this.getFormatedDate(jsondata.FinraSubmitLastExecutionReportDate): null;
      this.FinraCATFirstExceptionReportDate =jsondata.FinraCATFirstExceptionReportDate !=="" ? this.getFormatedDate(jsondata.FinraCATFirstExceptionReportDate): new Date();
      this.FinraCATLastExceptionReportDate =jsondata.FinraCATLastExceptionReportDate !=="" ? this.getFormatedDate(jsondata.FinraCATLastExceptionReportDate): new Date();
      this.LogsLastExcecutionReportDate =  jsondata.LogsLastExcecutionReportDate !=="" ? this.getFormatedDate(jsondata.LogsLastExcecutionReportDate):new Date();
      this.FirstClientReportDate =  jsondata.LogsLastExcecutionReportDate !=="" ? this.getFormatedDate(jsondata.FirstClientReportDate):new Date();
      this.LastClientReportDate =  jsondata.LastClientReportDate !=="" ? this.getFormatedDate(jsondata.LastClientReportDate):new Date();
      this.FirstClientReportDate =  jsondata.FirstClientReportDate !=="" ? this.getFormatedDate(jsondata.FirstClientReportDate):new Date();
      this.CATAnalyticsLastExecutionReportDate = jsondata.CATAnalyticsLastExecutionReportDate !=="" ? this.getFormatedDate(jsondata.CATAnalyticsLastExecutionReportDate):new Date();
      this.CAISLastReportDate = jsondata.CAISLastReportDate !=="" ? this.getFormatedDate(jsondata.CAISLastReportDate):new Date();
      this.CAISFinraLastReportDate = jsondata.CAISFinraLastReportDate !=="" ? this.getFormatedDate(jsondata.CAISFinraLastReportDate):this.CAISLastReportDate;
    
    }
    });
  }
  getFieldDictionary() {
    return this.sharedHttpClientService
      .post(
        this.urlsService.setAPIURl(
          APIURL.CAT_Exception_Summary_Field_Dictionary
        ),
        {}
      )

      .subscribe(data => {
        this.CAT_Field_Dictionary = data;
        this.storeCatFieldDictionary(data);
        this.getHandlingInstructionValues(); // Receive Handling Instructions from DB Choice Table
      });
  }
  getCAISFieldDictionary() {
    return this.sharedHttpClientService
      .get(
        this.urlsService.setAPIURl(
          APIURL.CAIS_Summary_Field_Dictionary
        )
      )
      .subscribe((data: any) => {
        let dataDetails = data;
        if(dataDetails.Data) {
          this.CAIS_Field_Dictionary = dataDetails.Data;
        }
      });
  }
  getMPIDServieList() {
    return this.sharedHttpClientService
    .post(
      this.urlsService.setAPIURl(
        APIURL.MPIDServiceList
      ),
      {
        "mpid":this.activeMPID,
      }
    )
    .subscribe((data) => {
      this.MPIDServiceList = data;
      this.isEnabledcaisFDIDService = data['caisService'];
      this.isEnabled606Service = data['regReporting'];
      /* Set MPID-CRDID */
      if(Object.keys(data).length > 0) {
        this.setCRDID(data.MPIDCRDID);
      }
    });
  }
  getFieldDictionaryObject(KeyName: string) {
    let index: number = 0;
    if (KeyName) {
      index = this.CAT_Field_Dictionary.findIndex(function (item: any, j: any) {
        return (
          item.field_Name.toLocaleLowerCase() == KeyName.toLocaleLowerCase()
        );
      });
    }
    if (index >= 0) {
      let error_code_object: any;
      error_code_object = this.CAT_Field_Dictionary[index];
      if (error_code_object) {
        return error_code_object;
      }
    }
  }
  getDropDownList(KeyName: string) {
    let index: number = 0;
    if (KeyName) {
      if(!Boolean(this.CAT_Field_Dictionary) ||  this.CAT_Field_Dictionary.length == 0) {
        this.CAT_Field_Dictionary = this.fetchCatFieldDictionary();
      }
      index = this.CAT_Field_Dictionary.findIndex(function (item: any, j: any) {
        return (
          item.field_Name.toLocaleLowerCase() == KeyName.toLocaleLowerCase()
        );
      });
    }
    if (index >= 0) {
      let error_code_object: any = this.CAT_Field_Dictionary[index];
      if (error_code_object) {
        let dropdownArray=[];
        dropdownArray = error_code_object.dropdownvalue;
        return dropdownArray.filter((key: { isActive: boolean; }) =>{ 
          return key.isActive == true
         });
      } else return
    } else return
  }

  getHandlingInstructionValues() {
    let handlingInstructionsValues :any = this.getFieldDictionaryObject('handlingInstructions');
    if(handlingInstructionsValues.dropdownvalue.length > 0) {
        for(let i=0; i<handlingInstructionsValues.dropdownvalue.length; i++) {
          this.handlingInstructionsJSON.push({
            "display":"true",
            "ui_columnname":handlingInstructionsValues.dropdownvalue[i].label,
            "db_columnname":handlingInstructionsValues.dropdownvalue[i].value,
            "datatype":"String",
            "mappingkey":handlingInstructionsValues.dropdownvalue[i].value,
            "dropdown":"NO",
            "isdefault":"false",
            "disabled":"false",
            "value":"",
            "dropdowntype":"singleselect",
            "dropdownvalue":""
          });
        }

      if(this.handlingInstructionsJSON.length > 0) {
        for (let i = 0; i < this.handlingInstructionsJSON.length; i++) {
          this.handlingInstructions[i] = {
              header: this.handlingInstructionsJSON[i].ui_columnname,
              field: (this.handlingInstructionsJSON[i].mappingkey),
          }
        }
      }
    }
  }

  getCountryCodeList() {
    return this.sharedHttpClientService
      .post(
        this.urlsService.setAPIURl(
          APIURL.CAIS_Country_List
        ),
        {}
      )
      .subscribe(data => {
        let CountryRegionDataList = data;
        this.Country_Code_List = CountryRegionDataList["CountryData"];
        this.Country_Region_Code_List = CountryRegionDataList["CountryRegionData"];
        /* Country Code List */
        if(this.Country_Code_List.length > 0) {
          for(let i=0; i<this.Country_Code_List.length; i++) {
            let CountryObj : any = {};
            CountryObj['label'] = this.Country_Code_List[i]['country_code'] + ' - ' + this.Country_Code_List[i]['country_name'];
            CountryObj['value'] = this.Country_Code_List[i]['country_code'];
            this.countryList.push(CountryObj);
          }
        }
        /* Country Region Code List */
        if(this.Country_Region_Code_List.length > 0) {
          for(let i=0; i<this.Country_Region_Code_List.length; i++) {
            let CountryRegionObj : any = {};
            CountryRegionObj['label'] = this.Country_Region_Code_List[i]['region_code'] + ' - ' + this.Country_Region_Code_List[i]['region_description'];
            CountryRegionObj['value'] = this.Country_Region_Code_List[i]['region_code'];
            this.countryRegionList.push(CountryRegionObj);
          }
        }
      });
  }

  getTimeInforceValue(key: string, fieldName: string, hasFieldDictionary: boolean, fieldDictionaryList: any[]) {
    let timeInForceValue = '';
    let fieldDropDownValues = this.getDropDownList(fieldName);
    if(fieldDropDownValues.length > 0) {
      let optedOptionDetail = fieldDropDownValues.filter((optionKey: { label: any; }) => optionKey.label === key);
      if(optedOptionDetail.length > 0) {
        let optionDataType = optedOptionDetail[0].dataType;
        if(hasFieldDictionary) {
          let reportDateIndex = fieldDictionaryList.findIndex((dictionaryKey: { fieldName: string; }) => dictionaryKey.fieldName==="reportDate");
          timeInForceValue = (!_.includes(['Date', 'Timestamp'], optionDataType) ? 'true' : fieldDictionaryList[reportDateIndex].jsonValue.replaceAll("-", ""));
        } else {
          let reportDateIndex = fieldDictionaryList.findIndex((dictionaryKey: { field_Name: string; }) => dictionaryKey.field_Name==="reportDate");
          timeInForceValue = (!_.includes(['Date', 'Timestamp'], optionDataType) ? 'true' : fieldDictionaryList[reportDateIndex].value.replaceAll("-", ""));
        }
      }
    }
    return timeInForceValue;
  }

  setClear() {
    this.activeMPID = null;
    this.MPIDList = null;
    this.uid = null;
  }
  setActiveMPID(activeMPID: any) {
    this.activeMPID = activeMPID;
  }
  setMPIDList(MPIDList: any) {
    this.MPIDList = MPIDList;
  }
  setUid(uid: any) {
    this.uid = uid;
  }
  getUserName() {
    return this.userName;
  }
  getUserFirstName() {
    return this.userFirstName;
  }
  public getActiveMPID() {
    return this.activeMPID;
  }
  getMPLIDList() {
    return this.MPIDList;
  }
  getUid() {
    return this.uid;
  }
  getDays() {
    return this.days;
  }
  SetDatesForClientData(data: any[]) {
    this.testDatesForClientReportedData = data;
  }
  getDatesForClientData() {
    return [this.LastClientReportDate,this.LastClientReportDate];
  }
  setCRDID(crdid: any) {
    this.CRDID = crdid;
  }
  getCRDID() {
    return this.CRDID;
  }
  get_CAT_Last_ReportDate() {
    return this.sharedHttpClientService.get(
      this.urlsService.setAPIURl1(
        APIURL.LastExecutionDate,
        this.getActiveMPID()
      )
    );
  }


  get_ODR_Last_ReportDate() {
    return this.sharedHttpClientService.get(
      this.urlsService.setAPIURl1(
        APIURL.ODR_Last_Execution_Dates,
        this.getActiveMPID()
      )
    );
  }

  get_Last_Reported_ClientDate() {
    return this.sharedHttpClientService.get(
      this.urlsService.setAPIURl1(
        APIURL.DatesForClientData,
        this.getActiveMPID()
      )
    );
  }
  getAccountNumbers() {
    this.sharedHttpClientService.get(
      this.urlService.setAPIURl(
        APIURL.CAT_AccountNumbers + '/' + this.getActiveMPID()))
        .subscribe((Result: any) => {
          this.accountNumbers = Result.data;
          
        });
      return this.accountNumbers;
  }

  getLTIDAccountNumbers() {
    this.sharedHttpClientService.get(
      this.urlService.setAPIURl(
        APIURL.CAT_LTIDAccountNumbers + '/' + this.getActiveMPID()))
        .subscribe((Result: any) => {
          this.ltidAccountNumbers = Result.data;
          
        });
      return this.ltidAccountNumbers;
  }

  enableFileExport(){
    if((this.futuFirms).includes(this.activeMPID)){
      return this.isRoleSuperUser() || "CAT Exception,CAT ROE Viewer,Finra Exception".includes(this.constantService.getApplicationName());
    }
    return true;
  }

   enableFileProcessing(){
    if((this.futuFirms).includes(this.activeMPID)){
      return this.isRoleSuperUser();
    }
    return true;
  }

  isRoleSuperUser() {
    return (this.role === "1") ? true : false;
    
  }

  isRoleFirmAdmin() {
    return (this.role === "2") ? true : false;
    
  }

  isRoleUser() {
    return (this.role === "3") ? true : false;
    
  }

  getUserRole() {
	return this.role
  }
  
  logUserActivity(userAction: string, userApplication: any, userLogDetail: any) {
    if(Object.keys(userLogDetail).length > 0) {
      userLogDetail = {
        'userAction': userAction,
        'application': (userApplication ? userApplication : this.constantService?.getApplicationName()),
        'firmMPID': this.getActiveMPID(),
        'userId': this.getUserName(),
        ...userLogDetail
      };
      this.sharedHttpClientService.post(
        this.urlsService.setAPIURl(APIURL.LogUserActivity),
        userLogDetail
      ).subscribe((response: any) => {
      });
    }
  }

  getHandlingInstructionValue(element1: any, EditViewCols: any, handlingInstructionData: any) {
    let handlingInstructions = {};
    if (handlingInstructionData[0] != undefined) {
      handlingInstructionData = handlingInstructionData[0];
    }
    for (let i = 0; i < EditViewCols.dropdownvalue.length; i++) {
      let element = EditViewCols.dropdownvalue[i];
      if (element.value == element1.header && element.dataType && handlingInstructionData[element1.header]) {
        if (element.dataType.toLocaleLowerCase() == "price" || element.dataType.toLocaleLowerCase() == "number" || element.dataType.toLocaleLowerCase() == "whole quantity" 
        || element.dataType.toLocaleLowerCase() == "real quantity"
        || element.dataType.toLocaleLowerCase() == "integer"
        || element.dataType.toLocaleLowerCase() == "unsigned") {
          return handlingInstructions = ({ [element1.header]: Number(handlingInstructionData[element1.header]) });
        } else if (element.dataType.toLocaleLowerCase() == "boolean") {
          if (handlingInstructionData[element1.header] &&
            (handlingInstructionData[element1.header] == "true"
              || handlingInstructionData[element1.header] == "false")) {
            return handlingInstructions = ({ [element1.header]: JSON.parse(handlingInstructionData[element1.header]) });
          }
        } else {
          return handlingInstructions = ({ [element1.header]: handlingInstructionData[element1.header] });
        }
      }
    }
    return { [element1.header]: handlingInstructionData[element1.header] };
  }

  getHandlingInstructionValueFinra(element1: any, EditViewCols: any, handlingInstructionData: any) {
    let handlingInstructions = {};
    if (handlingInstructionData[0] != undefined) {
      handlingInstructionData = handlingInstructionData[0]; 
    }
    for (let i = 0; i < EditViewCols.choiceDetails.length; i++) {
      let element = EditViewCols.choiceDetails[i];
      if (element.value == element1.header && element.valdatatype && handlingInstructionData[element1.header]) {
        if (element.valdatatype.toLocaleLowerCase() == "price" || element.valdatatype.toLocaleLowerCase() == "number" || element.valdatatype.toLocaleLowerCase() == "whole quantity" 
        || element.valdatatype.toLocaleLowerCase() == "real quantity"
        || element.valdatatype.toLocaleLowerCase() == "integer"
        || element.valdatatype.toLocaleLowerCase() == "unsigned") {
          return handlingInstructions = ({ [element1.header]: Number(handlingInstructionData[element1.header]) });
        } else if (element.valdatatype.toLocaleLowerCase() == "boolean") {
          if (handlingInstructionData[element1.header] &&
            (handlingInstructionData[element1.header] == "true"
              || handlingInstructionData[element1.header] == "false")) {
            return handlingInstructions = ({ [element1.header]: JSON.parse(handlingInstructionData[element1.header]) });
          }
        } else {
          return handlingInstructions = ({ [element1.header]: handlingInstructionData[element1.header] });
        }
      }
    }
    return { [element1.header]: handlingInstructionData[element1.header] };
  }

  /* Parse CSV Field Value while generating CSV Row */
  parseCell (ObjectValue: string) {
    // Replace all double quotes with two double quotes
    let parsedValue = ObjectValue.replace(/"/g, `""`);

    // If value contains comma, new-line or double-quote, enclose in double quotes
    parsedValue = /[",\n]/.test(parsedValue) ? `"${parsedValue}"` : parsedValue;

    return parsedValue;
  }

  /* Prepare CSV Data dynamically with Header & its Tabular Values */
  prepareCSVDataSet(dataSetHeaders: any[], dataSetFields: string | any[], dataSet: any[]) {
    const tableData = [];

    tableData.push(dataSetHeaders.join(",")); // CSV Header
    // CSV Body
    for (const row of dataSet) {
      const rowData = [];
      for(let i=0; i < dataSetFields.length; i++) {
        rowData.push((row[dataSetFields[i]] || row[dataSetFields[i]]>=0 ? this.parseCell(row[dataSetFields[i]].toString()) : ""));
      }
      tableData.push(rowData.join(","));
    }

    return tableData;
  }

  getAllWorkingDatesOfMonth(year: number, month: number) {
    let startDate = new Date(year, month, 1);
    let endDate = new Date(year, month + 1, 1);

    let dates = [];
    while (startDate < endDate) {
      if(new Date(startDate).getUTCDay()!=0 && new Date(startDate).getUTCDay()!=6) {
        dates.push(new Date(startDate).toLocaleDateString("en-US", { year: 'numeric', month: '2-digit', day: '2-digit' })); // clone the date object
      }
      startDate.setDate(startDate.getDate() + 1);
    }
  
    return dates;
  }

  getyyyyMMddDate(date: any):any {
    try {
      if(date.includes(".")) {
        date = date.split(".")[0];
      }
      return this.datePipe.transform(this.transformStringtoDate(date), "yyyy-MM-dd");
    }
    catch(e) {
    }
    return null;
  }

  storeCatFieldDictionary(data: any): void {
    const key = this.constantService.CAT_FIELD_DICTIONARY_KEY;
    this.constantService.storeInLocalStorage(key, data);
  }

  fetchCatFieldDictionary(): any[] {
    const key = this.constantService.CAT_FIELD_DICTIONARY_KEY;
    return this.constantService.fetchFromLocalStorage(key);
  }

  /* Receive Encode URL Parameters from Screen */
  getEncodedURLParameters() {
    let urlEncodedParams: object | any = new Object();

    this.activatedRoute.queryParams.subscribe((params: any) => {
      if(Object.keys(params).length > 0) {
        urlEncodedParams = JSON.parse(atob(Object.keys(params)[0]));
       }
    });

    /* Set Active MPID for the Screen */
    if(urlEncodedParams && urlEncodedParams["activeMPID"]) {
      this.setActiveMPID(urlEncodedParams["activeMPID"]);
    }

    return urlEncodedParams;
  }
  

  getUserMPIDList(user:any) {
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(APIURL.getUserMPIDList),
      { userName: user || this.userName }
    );
  }

} 